"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _RendererContext = require("./RendererContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @typedef {object} Props
 * @property {any[]} tools
 * @property {import("../../types/types").DocumentJson} document
 * @property {{name: string, key: string}} language
 * @property {any} renderer
 */

/**
 * @param {Props} props
 */
function ContentRenderer(_ref) {
  var tools = _ref.tools,
      document = _ref.document,
      language = _ref.language,
      Renderer = _ref.renderer;
  var contextValue = (0, _react.useMemo)(function () {
    return {
      document: document,
      tools: tools,
      language: language
    };
  }, [document, language, tools]);
  return __jsx(_RendererContext.RendererContext.Provider, {
    value: contextValue
  }, __jsx(Renderer, null));
}

var _default = ContentRenderer;
exports["default"] = _default;